import { Route, Switch } from 'react-router-dom';
import MenuManager from '@yooink/youtils/es/MenuManager';
import PropTypes from 'prop-types';
import { FaUsers } from 'react-icons/fa';
import { useLoadComponent } from '@yooink/youtils/es/hooks/useLoadComponent';
import { useHistory } from 'react-router';
import { useSpotlightActions } from '../../AppSpotlight';
import { GiCakeSlice } from 'react-icons/gi';

MenuManager.RegisterItem({
	path: '/users',
	name: 'Клиенты',
	icon: <FaUsers />,
	acl: 'users',
	position:8
});

export function UsersRoute (props) {
	const basePath = props.path || '/users';
	const getPath = (path = '') => `${basePath}${path}`;

	const history = useHistory();
	useSpotlightActions([{
		id: 'users.page',
		title: 'Пользователи',
		icon: <FaUsers />,
		onTrigger: () => history.push(getPath())
	}]);

	const List = useLoadComponent(() => import('./List'), {
		basePath
	});
	const View = useLoadComponent(() => import('./Edit').then((m) => m.EditUser), {
		basePath
	});
	const Settings = useLoadComponent(() => import('./UsersSettings').then((m) => m.UsersSettingsPage), {
		basePath
	});

	return (
		<>
			<Route
				exact
				path={getPath()}
				component={List}
			/>
			<Switch>
				<Route
					exact
					path={getPath('/settings')}
					component={Settings}
				/>
				<Route
					exact
					path={getPath('/:id')}
					component={View}
				/>
			</Switch>
		</>
	);
}

UsersRoute.propTypes = {
	path: PropTypes.string
};
